/* eslint-disable no-undef */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AppActions from '../../../flux/actions/AppActions';
import BlockedUserModal from './BlockedUserModal';

import { AuthContext, authRules, getRedirectUrl, useRequireAuth } from '@zg-rentals/particles-js-auth-hooks';

const AuthCheckWrapper = ({ brand, dispatch, children, isInWebView, router, requireStrongAuthentication = false }) => {
  const auth = useContext(AuthContext);
  const [blockedAlert, setBlockedAlert] = useState(null);

  if (__SERVER__) {
    const rules = authRules(auth, requireStrongAuthentication);
    const to = getRedirectUrl({
      rules,
      brand,
      isInWebView,
      currentPathname: router.location.pathname,
      queryString: router.location.search,
    });

    dispatch(AppActions.setServerSideRedirect(to, 302));
  }

  useRequireAuth({
    onBlocked: setBlockedAlert,
    requireStrongAuth: requireStrongAuthentication,
    currentPathname: router.location.pathname,
    queryString: router.location.search,
    brand,
    isInWebView,
  });

  if (!auth.user.loggedIn) return null;

  return (
    <div>
      {children}
      <BlockedUserModal {...{ body: blockedAlert }} />
    </div>
  );
};

AuthCheckWrapper.propTypes = {
  brand: PropTypes.oneOf(['zillow', 'hotpads', 'trulia']),
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isInWebView: PropTypes.bool,
  router: PropTypes.shape({
    location: PropTypes.shape({
      hash: PropTypes.string,
      key: PropTypes.string,
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
  requireStrongAuthentication: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  router: state.router,
  isInWebView: state.app.isInWebView,
});

export default connect(mapStateToProps)(AuthCheckWrapper);
